const conf = {
  NC_URL: "https://nextcloud.meiessn.de",
  BOARD_ENDPOINT: "/index.php/apps/deck/api/v1.1/boards",
};

export default conf;
